document.addEventListener("DOMContentLoaded",function(){var blogContent=document.getElementById("blog-content");var tocList=document.getElementById("toc-list");if(blogContent&&tocList){var headings=blogContent.querySelectorAll("h2");headings.forEach(function(heading,index){var anchor="heading-"+index;heading.id=anchor;var listItem=document.createElement("li");var link=document.createElement("a");link.href="#"+anchor;link.textContent=heading.textContent;listItem.appendChild(link);tocList.appendChild(listItem)})}});

/* Rabatt-Badge: Zeitraum zusaetzlich clientseitig pruefen.
   Noetig, weil Shopify Seiten kurzzeitig cached und die Liquid-Pruefung dann aus
   dem Cache stammen kann. Konfiguration kommt ueber data-Attribute aus dem
   Snippet 'discount-badge'. Verglichen werden Unix-Timestamps, das ist
   zeitzonenunabhaengig. */
function syncDiscountBadges() {
  var badges = document.querySelectorAll('.js-discount-badge');
  if (!badges.length) return;

  var nowSec = Math.floor(Date.now() / 1000);

  badges.forEach(function (badge) {
    // Im Theme-Editor bleibt das Badge sichtbar, wenn so eingestellt.
    if (badge.dataset.badgePreview === 'true') return;

    var start = parseInt(badge.dataset.badgeStart, 10) || 0;
    var end = parseInt(badge.dataset.badgeEnd, 10) || 0;
    var visible = (start === 0 || nowSec >= start) && (end === 0 || nowSec <= end);

    badge.classList.toggle('is-schedule-hidden', !visible);
  });
}

// Damit nachgeladene Produktkarten (Collection "Mehr laden") ebenfalls pruefen koennen.
window.syncDiscountBadges = syncDiscountBadges;

document.addEventListener('DOMContentLoaded', function () {
  syncDiscountBadges();
  setInterval(syncDiscountBadges, 30000);
});

const menuDrawer = document.getElementById('menu-drawer');
if (menuDrawer) {
  const observer = new MutationObserver(() => {
    const isOpen =
      menuDrawer.classList.contains('menu-opening') ||
      menuDrawer.classList.contains('menu-open') ||
      menuDrawer.hasAttribute('open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  observer.observe(menuDrawer, { attributes: !0, attributeFilter: ['class', 'open'] });
}

/* Reviews.io: Sterne auf den Produktkarten.

   Das App-Embed "Rating Snippet" laedt widget.reviews.io/rating-snippet/dist.js
   und stellt global ratingSnippet(klasse, optionen) bereit. Wir rufen es mit
   einer eigenen Klasse auf statt mit der App-Klasse ruk_rating_snippet, damit
   die Einstellungen der App unberuehrt bleiben und wir hier eigene setzen
   koennen: keine Zusatzwoerter hinter der Zahl (text: ''), kein Popup beim
   Klick, keine Sprungmarke. Die Farben muessen hier stehen und nicht in
   cc_style.css: das Widget schreibt sie als inline style auf die Elemente, und
   zwar auch dann, wenn man sie weglaesst - dann mit seinen Vorgaben Gruen und
   #333. Groessen und Abstaende macht weiterhin cc_style.css.

   Das Widget haengt die Sterne per innerHTML in das Element und markiert es mit
   data-retrieved; ein zweiter Aufruf ueberspringt bereits gefuellte Karten. */
function syncCardRatings() {
  if (typeof ratingSnippet !== 'function') return false;
  if (typeof reviewsIoStore === 'undefined' || !reviewsIoStore) return false;
  if (!document.querySelector('.msports_rating_snippet:not([data-retrieved])')) return true;

  ratingSnippet('msports_rating_snippet', {
    store: reviewsIoStore,
    color: '#000000',
    textClr: '#888888',
    text: '',
    lang: typeof reviewsIoLang !== 'undefined' && reviewsIoLang ? reviewsIoLang : 'de',
    mode: 'default',
    showEmptyStars: false,
    snippetPopup: false,
    anchorToReviewsWidget: false
  });

  return true;
}

// Damit nachgeladene Produktkarten (Collection "Mehr laden") Sterne bekommen.
window.syncCardRatings = syncCardRatings;

/* Beide Skripte liegen als defer im head, die Reihenfolge ist nicht garantiert.
   Deshalb nach dem load-Event kurz nachfassen, bis ratingSnippet da ist. */
window.addEventListener('load', function () {
  var attempts = 0;
  (function tick() {
    attempts += 1;
    if (syncCardRatings()) return;
    if (attempts < 20) window.setTimeout(tick, 200);
  })();
});

/* Neues mobiles Menue (Vorschau) - snippets/mobile-menu-drawer.liquid.

   Blaetterlogik statt Akkordeon: die Startseite und je eine Unterseite pro
   Kategorie liegen nebeneinander im DOM, umgeschaltet wird ueber Klassen.

   Bewusst per Delegation auf document statt Listener pro Element: der Header
   wird im Theme-Editor neu gerendert, so ueberlebt die Steuerung das ohne
   doppelte Bindungen.

   Warum ueberhaupt eigenes JS: Dawns MenuDrawer haengt sich im Konstruktor an
   jeden Button und jedes Summary innerhalb von <header-drawer>, deshalb nutzt
   das Markup div[role="button"]. */
(function () {
  function nav() {
    return document.querySelector('.msports_mm');
  }

  function scroller() {
    return document.querySelector('.menu-drawer__navigation-container');
  }

  function toTop() {
    var box = scroller();
    if (box) box.scrollTop = 0;
  }

  /* Der Fokus muss beim Blaettern mitwandern. Sonst steht er auf einem
     Element, das gleich display:none bekommt - der Browser gibt den Fokus dann
     an den body ab, und Dawns onFocusOut schliesst daraufhin den ganzen
     Drawer, weil der aktive Knoten nicht mehr darin liegt. */
  function focusIn(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function showRoot(animate) {
    var wrap = nav();
    if (!wrap) return;

    var offen = wrap.querySelector('.msports_mm_sub.is-open');
    var zurueckZu = null;
    if (offen) zurueckZu = wrap.querySelector('[data-msports-mm-open="' + offen.id + '"]');

    wrap.querySelectorAll('.msports_mm_sub.is-open').forEach(function (sub) {
      sub.classList.remove('is-open');
    });
    wrap.querySelectorAll('[data-msports-mm-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    wrap.classList.remove('is-sub');

    var root = wrap.querySelector('[data-msports-mm-root]');
    if (root && animate) {
      root.classList.remove('is-back');
      // Neustart der Animation erzwingen, sonst laeuft sie beim zweiten Mal nicht.
      void root.offsetWidth;
      root.classList.add('is-back');
      focusIn(zurueckZu);
    }
    toTop();
  }

  function showSub(id) {
    var wrap = nav();
    var sub = id ? document.getElementById(id) : null;
    if (!wrap || !sub) return;
    showRoot(false);
    wrap.classList.add('is-sub');
    sub.classList.add('is-open');
    var trigger = wrap.querySelector('[data-msports-mm-open="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    focusIn(sub.querySelector('[data-msports-mm-back]'));
    toTop();
  }

  function closeDrawer() {
    var drawer = document.querySelector('header-drawer');
    var summary = drawer && drawer.querySelector('summary.header__icon--menu');
    // Ueber Dawns eigenen Umschalter, damit Animation, Fokus und
    // body-overflow so aufgeraeumt werden wie beim Klick auf das Kreuz oben.
    if (summary) summary.click();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-msports-mm-open]');
    if (opener) {
      event.preventDefault();
      showSub(opener.getAttribute('data-msports-mm-open'));
      return;
    }

    if (target.closest('[data-msports-mm-back]')) {
      event.preventDefault();
      showRoot(true);
      return;
    }

    if (target.closest('[data-msports-mm-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var el = target.closest('[data-msports-mm-open],[data-msports-mm-back],[data-msports-mm-close]');
    if (!el) return;
    event.preventDefault();
    el.click();
  });

  /* Escape soll auf einer Unterseite erst zurueckblaettern statt das ganze
     Menue zu schliessen. Dawn hoert auf <header-drawer>, deshalb hier in der
     Capture-Phase abfangen, bevor der Klick dort ankommt. */
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    var wrap = nav();
    if (!wrap || !wrap.classList.contains('is-sub')) return;
    event.stopPropagation();
    showRoot(true);
  }, true);

  /* Beim Schliessen zurueck auf die Startseite, damit das Menue beim naechsten
     Oeffnen nicht mitten in einer Kategorie steht. */
  function watchDrawer() {
    var details = document.querySelector('header-drawer details');
    if (!details || details.dataset.msportsMmWatched === 'true') return;
    details.dataset.msportsMmWatched = 'true';
    new MutationObserver(function () {
      if (!details.hasAttribute('open')) showRoot(false);
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  document.addEventListener('DOMContentLoaded', watchDrawer);
  document.addEventListener('shopify:section:load', watchDrawer);
  if (document.readyState !== 'loading') watchDrawer();
})();

/* ---------- Warenkorb-Slider: Rad und Wisch auf die Artikelliste umlenken ----------
   Seit die Kasse fest unten steht (cc_style.css, "Kasse immer sichtbar"), scrollt
   nicht mehr der ganze Warenkorb, sondern nur noch die Liste .items.

   Zwei Loecher, die das aufreisst:
   1. Wer Rad oder Finger ueber Banner, Upsell-Karussell oder Footer hat, scrollt
      ins Leere - vorher scrollte der ganze Warenkorb, egal wo der Zeiger stand.
   2. Auf iOS sperrt Slide Cart das touchmove mit body-scroll-lock, und zwar
      bezogen auf den Warenkorb als Ganzes. Seit der steht, laesst der Lock gar
      nichts mehr durch - auch nicht auf der Liste selbst. Gemessen: Wisch auf der
      Liste bewegt nichts, Wisch daneben (ueber unsere Weiterleitung) schon.

   Deshalb uebernimmt das Wischen hier komplett und setzt scrollTop selbst. Das
   Ereignis kommt trotz preventDefault der App an. Quer gewischt wird nicht
   angefasst, sonst laesst sich das Upsell-Karussell nicht mehr blaettern. */
(function () {
  function cartOf(target) {
    return target && target.closest ? target.closest('#slidecarthq .slidecarthq') : null;
  }

  /* Die Liste, aber nur wenn es ueberhaupt etwas zu scrollen gibt. */
  function listIn(cart) {
    if (!cart) return null;
    var items = cart.querySelector('.items');
    return items && items.scrollHeight > items.clientHeight + 1 ? items : null;
  }

  function shift(items, delta, event) {
    var before = items.scrollTop;
    items.scrollTop = before + delta;
    /* Am Anschlag nicht abfangen, damit die Seite darunter uebernehmen kann. */
    if (items.scrollTop !== before) event.preventDefault();
  }

  document.addEventListener('wheel', function (event) {
    var cart = cartOf(event.target);
    if (!cart || event.target.closest('.items') || event.target.closest('.upsell-options')) return;
    var items = listIn(cart);
    if (items) shift(items, event.deltaY, event);
  }, { passive: false });

  var touch = null;

  document.addEventListener('touchstart', function (event) {
    var cart = cartOf(event.target);
    if (!cart || event.target.closest('.upsell-options')) { touch = null; return; }
    var point = event.touches[0];
    touch = { x: point.clientX, y: point.clientY, lastY: point.clientY, axis: null };
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!touch) return;
    var point = event.touches[0];

    if (touch.axis === null) {
      var dx = Math.abs(point.clientX - touch.x);
      var dy = Math.abs(point.clientY - touch.y);
      if (dx + dy < 6) return;
      touch.axis = dy > dx ? 'y' : 'x';
    }
    if (touch.axis !== 'y') return;

    var items = listIn(cartOf(event.target));
    if (items) shift(items, touch.lastY - point.clientY, event);
    touch.lastY = point.clientY;
  }, { passive: false });

  document.addEventListener('touchend', function () { touch = null; }, { passive: true });
})();
